import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
const axios = require('axios').default;
import { toast } from 'react-toastify';

import {
  offsetDateForServer
} from '../../../shared/timeZoneLogic';

const formatDateTime = (date) => {
  if (!date) return "";
  const options = { 
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  return new Date(date).toLocaleString('en-US', options);
};

const isValidUrl = (url) => {
  if (!url) return false;
  try {
    new URL(url);
    return url.startsWith('http://') || url.startsWith('https://');
  } catch (e) {
    return false;
  }
};

const AnnounceAndOnSale = ({
  csrfToken,
  team,
  tour,
  tourChanged
}) => {
  const [localTour, setLocalTour] = useState({
    ...tour,
    announce_at: tour.announce_at ? new Date(tour.announce_at) : "",
    event_state: tour.event_state || "",
    enable_lottery: tour.enable_lottery || false,
    presale_start_at: tour.presale_start_at ? new Date(tour.presale_start_at) : "",
    presale_end_at: tour.presale_end_at ? new Date(tour.presale_end_at) : "",
    presale_code: tour.presale_code || "",
    presale_url: tour.presale_url || "",
    public_on_sale_start_at: tour.public_on_sale_start_at ? new Date(tour.public_on_sale_start_at) : "",
    public_on_sale_end_at: tour.public_on_sale_end_at ? new Date(tour.public_on_sale_end_at) : "",
    public_on_sale_url: tour.public_on_sale_url || "",
    vip_start_at: tour.vip_start_at ? new Date(tour.vip_start_at) : "",
    vip_end_at: tour.vip_end_at ? new Date(tour.vip_end_at) : "",
    vip_url: tour.vip_url || ""
  });

  const [originalTour, setOriginalTour] = useState({
    announce_at: tour.announce_at ? new Date(tour.announce_at) : "",
    event_state: tour.event_state || "",
    enable_lottery: tour.enable_lottery || false,
    presale_start_at: tour.presale_start_at ? new Date(tour.presale_start_at) : "",
    presale_end_at: tour.presale_end_at ? new Date(tour.presale_end_at) : "",
    presale_code: tour.presale_code || "",
    presale_url: tour.presale_url || "",
    public_on_sale_start_at: tour.public_on_sale_start_at ? new Date(tour.public_on_sale_start_at) : "",
    public_on_sale_end_at: tour.public_on_sale_end_at ? new Date(tour.public_on_sale_end_at) : "",
    public_on_sale_url: tour.public_on_sale_url || "",
    vip_start_at: tour.vip_start_at ? new Date(tour.vip_start_at) : "",
    vip_end_at: tour.vip_end_at ? new Date(tour.vip_end_at) : "",
    vip_url: tour.vip_url || ""
  });

  useEffect(() => {
    const newTourState = {
      ...tour,
      announce_at: tour.announce_at ? new Date(tour.announce_at) : "",
      event_state: tour.event_state || "",
      enable_lottery: tour.enable_lottery || false,
      presale_start_at: tour.presale_start_at ? new Date(tour.presale_start_at) : "",
      presale_end_at: tour.presale_end_at ? new Date(tour.presale_end_at) : "",
      presale_code: tour.presale_code || "",
      presale_url: tour.presale_url || "",
      public_on_sale_start_at: tour.public_on_sale_start_at ? new Date(tour.public_on_sale_start_at) : "",
      public_on_sale_end_at: tour.public_on_sale_end_at ? new Date(tour.public_on_sale_end_at) : "",
      public_on_sale_url: tour.public_on_sale_url || "",
      vip_start_at: tour.vip_start_at ? new Date(tour.vip_start_at) : "",
      vip_end_at: tour.vip_end_at ? new Date(tour.vip_end_at) : "",
      vip_url: tour.vip_url || ""
    };
    
    setLocalTour(newTourState);
    
    setOriginalTour({
      announce_at: tour.announce_at ? new Date(tour.announce_at) : "",
      event_state: tour.event_state || "",
      enable_lottery: tour.enable_lottery || false,
      presale_start_at: tour.presale_start_at ? new Date(tour.presale_start_at) : "",
      presale_end_at: tour.presale_end_at ? new Date(tour.presale_end_at) : "",
      presale_code: tour.presale_code || "",
      presale_url: tour.presale_url || "",
      public_on_sale_start_at: tour.public_on_sale_start_at ? new Date(tour.public_on_sale_start_at) : "",
      public_on_sale_end_at: tour.public_on_sale_end_at ? new Date(tour.public_on_sale_end_at) : "",
      public_on_sale_url: tour.public_on_sale_url || "",
      vip_start_at: tour.vip_start_at ? new Date(tour.vip_start_at) : "",
      vip_end_at: tour.vip_end_at ? new Date(tour.vip_end_at) : "",
      vip_url: tour.vip_url || ""
    });
  }, [tour]);

  const datesEqual = (date1, date2) => {
    if (date1 === date2) return true;
    if (!date1 && !date2) return true;
    if (!date1 || !date2) return false;
    if (date1 === "" && date2 === "") return true;
    if (date1 === "" || date2 === "") return false;
    return new Date(date1).getTime() === new Date(date2).getTime();
  };

  const hasChanges = () => {
    return (
      !datesEqual(localTour.announce_at, originalTour.announce_at) ||
      localTour.event_state !== originalTour.event_state ||
      localTour.enable_lottery !== originalTour.enable_lottery ||
      !datesEqual(localTour.presale_start_at, originalTour.presale_start_at) ||
      !datesEqual(localTour.presale_end_at, originalTour.presale_end_at) ||
      localTour.presale_code !== originalTour.presale_code ||
      localTour.presale_url !== originalTour.presale_url ||
      !datesEqual(localTour.public_on_sale_start_at, originalTour.public_on_sale_start_at) ||
      !datesEqual(localTour.public_on_sale_end_at, originalTour.public_on_sale_end_at) ||
      localTour.public_on_sale_url !== originalTour.public_on_sale_url ||
      !datesEqual(localTour.vip_start_at, originalTour.vip_start_at) ||
      !datesEqual(localTour.vip_end_at, originalTour.vip_end_at) ||
      localTour.vip_url !== originalTour.vip_url
    );
  };

  const resetToOriginal = () => {
    setLocalTour({...originalTour});
  };

  const canSaveTour = (
    hasChanges() &&
    (
      !localTour.presale_url ||
      localTour.presale_url.length === 0 ||
      isValidUrl(localTour.presale_url)
    ) &&
    (
      !localTour.public_on_sale_url ||
      localTour.public_on_sale_url.length === 0 ||
      isValidUrl(localTour.public_on_sale_url)
    ) &&
    (
      !localTour.vip_url ||
      localTour.vip_url.length === 0 ||
      isValidUrl(localTour.vip_url)
    )
  );

  const updateTour = (tourData) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.put(`/teams/${team.id}/tours/${tour.id}`, {
        tour: {
          announce_at: offsetDateForServer(tourData.announce_at),
          event_state: tourData.event_state,
          enable_lottery: tourData.enable_lottery,
          presale_start_at: offsetDateForServer(tourData.presale_start_at),
          presale_end_at: offsetDateForServer(tourData.presale_end_at),
          presale_code: tourData.presale_code,
          presale_url: tourData.presale_url,
          public_on_sale_start_at: offsetDateForServer(tourData.public_on_sale_start_at),
          public_on_sale_end_at: offsetDateForServer(tourData.public_on_sale_end_at),
          public_on_sale_url: tourData.public_on_sale_url,
          vip_start_at: offsetDateForServer(tourData.vip_start_at),
          vip_end_at: offsetDateForServer(tourData.vip_end_at),
          vip_url: tourData.vip_url
        }
      })
      .then(({data}) => {
        tourChanged(data);
        toast.success("Tour settings saved successfully", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 3000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  return (
    <div>
      <div style={{
        marginTop: '16px',
        marginBottom: '20px',
        borderBottom: "1px solid #E9EAEB",
        paddingBottom: '24px'
      }}>
        <div className='row'>
          <div className='col-12 d-flex justify-content-between'>
            <div>
              <p className="mb-0" style={{fontSize: '18px', fontWeight: '600'}}>
                Announce & On-Sale
              </p>
              <p className="mb-0" style={{fontSize: '14px'}}>
                All dates and times will be applied to each show on the tour and can be modified individually.
                This step can be skipped until a later date.
              </p>
            </div>
            <div>
              <span className="badge badge-light small"
                    style={{
                      backgroundColor: "#FAFAFA",
                      border: "1px solid #E9EAEB",
                      color: "#414651",
                      padding: "2px 8px",
                      fontWeight: "400"
                    }}>
                Optional
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <form onSubmit={(e) => {
        e.preventDefault();
        
        if (!canSaveTour) {
          return;
        }
        
        updateTour(localTour);
      }}>
        <p style={{fontSize: '16px', fontWeight: '600', marginBottom: '25px'}}>
          Announce
        </p>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label 
              htmlFor="tour-announce" 
              style={{fontSize: '14px', fontWeight: '600'}}
            >
              Announce Date/Time
            </label>
          </div>
          <div className="col-12 col-md-8">
            <Flatpickr
              className="form-control"
              id="tour-announce"
              style={{ border: "1px solid #D5D7DA" }}
              value={localTour.announce_at || ""}
              onClose={([date]) => setLocalTour({...localTour, announce_at: date})}
              placeholder="Enter date & time"
              options={{
                enableTime: true,
                dateFormat: "M j, Y - h:iK",
                time_24hr: false,
                allowInput: false,
                formatDate: (date) => formatDateTime(date)
              }}
            />
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label 
              htmlFor="tour-state" 
              style={{fontSize: '14px', fontWeight: '600'}}
            >
              Event State
            </label>
          </div>
          <div className="col-12 col-md-8">
            <select 
              className="form-control" 
              id="tour-state"
              style={{ border: "1px solid #D5D7DA" }}
              value={localTour.event_state || ""}
              onChange={e => setLocalTour({...localTour, event_state: e.target.value})}
            >
              <option value="">Select state</option>
              <option value="Confirmed">Confirmed</option>
              <option value="Tentative">Tentative</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
        </div>
        <p style={{fontSize: '16px', fontWeight: '600', marginBottom: '25px', marginTop: '20px'}}>
          On-Sale
        </p>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label 
              htmlFor="tour-lottery" 
              style={{fontSize: '14px', fontWeight: '600'}}
            >
              Ticket Lottery
            </label>
          </div>
          <div className="col-12 col-md-8">
            <div style={{"border": "1px solid #D5D7DA", "borderRadius": "12px", "padding": "16px"}}>
              <input 
                type="checkbox" 
                id="tour-lottery"
                checked={!!localTour.enable_lottery}
                onChange={e => setLocalTour({...localTour, enable_lottery: e.target.checked})}
              /> 
              <label htmlFor="tour-lottery" style={{marginLeft: '8px', fontSize: '14px', marginBottom: '0px'}}>
                Yes, enable lottery system
              </label>
            </div>
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '10px'}}>
          <div className="col-12 col-md-4">
            <label style={{fontSize: '14px', fontWeight: '600'}}>Presale</label>
          </div>
          <div className="col-12 col-md-8">
            <div className="form-row" style={{marginBottom: '10px'}}>
              <div className="col-6 col-md-12 col-xl-6">
                <label htmlFor="tour-presale-begin" style={{fontSize: '14px', marginBottom: '6px'}}>
                  Begin Date/Time <span style={{color: "#1982C4"}}>*</span>
                </label>
                <Flatpickr
                  className="form-control mr-2 mb-2"
                  id="tour-presale-begin"
                  style={{border: '1px solid #D5D7DA'}}
                  placeholder="Enter date & time"
                  value={localTour.presale_start_at || ""}
                  onClose={([date]) => setLocalTour({...localTour, presale_start_at: date})}
                  options={{
                    enableTime: true,
                    dateFormat: "M j, Y - h:iK",
                    time_24hr: false,
                    allowInput: false,
                    formatDate: (date) => formatDateTime(date)
                  }}
                />
              </div>
              <div className="col-6 col-md-12 col-xl-6">
                <label htmlFor="tour-presale-end" style={{fontSize: '14px', marginBottom: '6px'}}>
                  End Date/Time <span style={{color: "#1982C4"}}>*</span>
                </label>
                <Flatpickr
                  className="form-control mr-2 mb-2"
                  id="tour-presale-end"
                  style={{border: '1px solid #D5D7DA'}}
                  placeholder="Enter date & time"
                  value={localTour.presale_end_at || ""}
                  onClose={([date]) => setLocalTour({...localTour, presale_end_at: date})}
                  options={{
                    enableTime: true,
                    dateFormat: "M j, Y - h:iK",
                    time_24hr: false,
                    allowInput: false,
                    formatDate: (date) => formatDateTime(date)
                  }}
                />
              </div>
            </div>
            <div className="form-group" style={{marginBottom: '20px'}}>
              <label htmlFor="tour-presale-code" style={{fontSize: '14px', marginBottom: '6px'}}>
                Code <span style={{color: "#1982C4"}}>*</span>
              </label>
              <input 
                type="text" 
                id="tour-presale-code"
                className="form-control" 
                placeholder="Enter presale code" 
                style={{border: '1px solid #D5D7DA'}}
                value={localTour.presale_code || ""}
                onChange={e => setLocalTour({...localTour, presale_code: e.target.value})}
              />
            </div>
            <div className="form-group" style={{marginBottom: '20px'}}>
              <label htmlFor="tour-presale-url" style={{fontSize: '14px', marginBottom: '6px'}}>
                URL <span style={{color: "#1982C4"}}>*</span>
              </label>
              <input 
                type="text" 
                id="tour-presale-url"
                className="form-control" 
                placeholder="Enter url" 
                style={{border: '1px solid #D5D7DA'}}
                value={localTour.presale_url || ""}
                onChange={e => setLocalTour({...localTour, presale_url: e.target.value})}
              />
            </div>
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '10px'}}>
          <div className="col-12 col-md-4">
            <label style={{fontSize: '14px', fontWeight: '600'}}>
              Public on-sale
            </label>
          </div>
          <div className="col-12 col-md-8">
            <div className="form-row" style={{marginBottom: '10px'}}>
              <div className="col-6 col-md-12 col-xl-6">
                <label htmlFor="tour-public-on-sale-start" style={{fontSize: '14px', marginBottom: '6px'}}>
                  Begin Date/Time <span style={{color: "#1982C4"}}>*</span>
                </label>
                <Flatpickr
                  className="form-control mr-2 mb-2"
                  id="tour-public-on-sale-start"
                  style={{border: '1px solid #D5D7DA'}}
                  placeholder="Enter date & time"
                  value={localTour.public_on_sale_start_at || ""}
                  onClose={([date]) => setLocalTour({
                    ...localTour, 
                    public_on_sale_start_at: date
                  })}
                  options={{
                    enableTime: true,
                    dateFormat: "M j, Y - h:iK",
                    time_24hr: false,
                    allowInput: false,
                    formatDate: (date) => formatDateTime(date)
                  }}
                />
              </div>
              <div className="col-6 col-md-12 col-xl-6">
                <label htmlFor="tour-public-on-sale-end" style={{fontSize: '14px', marginBottom: '6px'}}>
                  End Date/Time <span style={{color: "#1982C4"}}>*</span>
                </label>
                <Flatpickr
                  className="form-control mr-2 mb-2"
                  id="tour-public-on-sale-end"
                  style={{border: '1px solid #D5D7DA'}}
                  placeholder="Enter date & time"
                  value={localTour.public_on_sale_end_at || ""}
                  onClose={([date]) => setLocalTour({
                    ...localTour, 
                    public_on_sale_end_at: date
                  })}
                  options={{
                    enableTime: true,
                    dateFormat: "M j, Y - h:iK",
                    time_24hr: false,
                    allowInput: false,
                    formatDate: (date) => formatDateTime(date)
                  }}
                />
              </div>
            </div>
            <div className="form-group" style={{marginBottom: '20px'}}>
              <label htmlFor="tour-public-on-sale-url" style={{fontSize: '14px', marginBottom: '6px'}}>
                URL <span style={{color: "#1982C4"}}>*</span>
              </label>
              <input 
                type="text" 
                id="tour-public-on-sale-url"
                className="form-control" 
                placeholder="Enter url" 
                style={{border: '1px solid #D5D7DA'}}
                value={localTour.public_on_sale_url || ""}
                onChange={e => setLocalTour({...localTour, public_on_sale_url: e.target.value})}
              />
            </div>
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '10px'}}>
          <div className="col-12 col-md-4">
            <label style={{fontSize: '14px', fontWeight: '600'}}>VIP</label>
          </div>
          <div className="col-12 col-md-8">
            <div className="form-row" style={{marginBottom: '10px'}}>
              <div className="col-6 col-md-12 col-xl-6">
                <label htmlFor="tour-vip-start" style={{fontSize: '14px', marginBottom: '6px'}}>
                  Begin Date/Time <span style={{color: "#1982C4"}}>*</span>
                </label>
                <Flatpickr
                  className="form-control mr-2 mb-2"
                  id="tour-vip-start"
                  style={{border: '1px solid #D5D7DA'}}
                  placeholder="Enter date & time"
                  value={localTour.vip_start_at || ""}
                  onClose={([date]) => setLocalTour({...localTour, vip_start_at: date})}
                  options={{
                    enableTime: true,
                    dateFormat: "M j, Y - h:iK",
                    time_24hr: false,
                    allowInput: false,
                    formatDate: (date) => formatDateTime(date)
                  }}
                />
              </div>
              <div className="col-6 col-md-12 col-xl-6">
                <label htmlFor="tour-vip-end" style={{fontSize: '14px', marginBottom: '6px'}}>
                  End Date/Time <span style={{color: "#1982C4"}}>*</span>
                </label>
                <Flatpickr
                  className="form-control mr-2 mb-2"
                  id="tour-vip-end"
                  style={{border: '1px solid #D5D7DA'}}
                  placeholder="Enter date & time"
                  value={localTour.vip_end_at || ""}
                  onClose={([date]) => setLocalTour({...localTour, vip_end_at: date})}
                  options={{
                    enableTime: true,
                    dateFormat: "M j, Y - h:iK",
                    time_24hr: false,
                    allowInput: false,
                    formatDate: (date) => formatDateTime(date)
                  }}
                />
              </div>
            </div>
            <div className="form-group" style={{marginBottom: '20px'}}>
              <label htmlFor="tour-vip-url" style={{fontSize: '14px', marginBottom: '6px'}}>
                URL <span style={{color: "#1982C4"}}>*</span>
              </label>
              <input 
                type="text" 
                id="tour-vip-url"
                className="form-control" 
                placeholder="Enter url" 
                style={{border: '1px solid #D5D7DA'}}
                value={localTour.vip_url || ""}
                onChange={e => setLocalTour({...localTour, vip_url: e.target.value})}
              />
            </div>
          </div>
        </div>
        <div className="form-row" style={{margin: '0px 0px 20px 0px'}}>
          <div className="col-12">
            <hr style={{borderTop: '1px solid #E9EAEB', marginTop: '0px'}} />
          </div>
        </div>
        <div className="form-row" style={{margin: '35px 0px 20px 0px'}}>
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              {hasChanges() && (
                <a 
                  href="#"
                  style={{fontSize: '14px'}}
                  onClick={(e) => {
                    e.preventDefault();
                    resetToOriginal();
                  }}
                >
                  Cancel
                </a>
              )}
            </div>
            <div className="text-right">
              <button 
                type="submit"
                style={{fontSize: '14px'}}
                disabled={!canSaveTour}
                className="btn btn-primary"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

AnnounceAndOnSale.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  tour: PropTypes.object.isRequired,
  tourChanged: PropTypes.func.isRequired
};

export default AnnounceAndOnSale;
